export enum ServicePeriods {
  NONE = 'none',
  SERVICE_DATE = 'service_date',
  SERVICE_PERIOD = 'service_period'
}
